import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import _ from 'lodash';
import MediaQuery from 'react-responsive';
import { RenderHiddenField, RenderSubmitButton } from '../../../common/form';
import { updateGuestRsvpV2, resetGuestRsvpSuccess } from '../../../../actions/PublicWebsiteActions';
import EventDetails from './RsvpForm/EventDetails';
import ScrollButton from './RsvpForm/ScrollButton';
import EventRsvp from './RsvpForm/EventRsvp';
import RsvpFormHeader from './RsvpForm/RsvpFormHeader';
import RsvpSuccess from './RsvpForm/RsvpSuccess';
import { resetGuestSearchesNotActedOn, scrollToTop } from './RsvpForm/utils';


class GuestRsvpForm extends Component {
  constructor(props) {
    super(props);

    this.handleScroll = this.handleScroll.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);

    this.state = {
      step: 'intro',
    };
  }

  handleScroll(eventIndex) {
    const scrollTarget = this[`events[${eventIndex + 1}]`];
    if (scrollTarget) {
      scrollTarget.scrollIntoView({ behavior: 'smooth' });
    }
  }

  handleNextStep(step) {
    this.setState({
      step
    });
    scrollToTop();
  }

  render() {
    const {
      wedding,
      guests,
      events,
      pristine,
      submitting,
      valid,
      forPreview,
      mealOptionsById,
      selector,
      handleSubmit,
      success,
      onEditRsvp,
      page,
      guestGroupRsvp,
    } = this.props;
    const { step } = this.state;
    let numEventsRequiringRsvp = 0;
    if (events) {
      numEventsRequiringRsvp = events.filter(event => event.collect_rsvps === true).length;
    }
    const noPlusOne = selector('guests') && selector('guests').length - 1 === 0;
    const onePlusOne = selector('guests') && selector('guests').length - 1 === 1;

    return (
      <div>
        {events && !success && step !== 'intro' && step < events.length && (
          <div className="visible-xs">
            {step === 0 ? (
              <div onClick={() => this.handleNextStep('intro')}><h4>&lsaquo; Back</h4></div>
            ) : (
              <div onClick={() => this.handleNextStep(step - 1)}><h4>&lsaquo; Back</h4></div>
            )}
          </div>
        )}
        <div className="hidden-xs">
          <RsvpFormHeader page={page} guestGroupRsvp={guestGroupRsvp} wedding={wedding} />
        </div>
        <div className="visible-xs">
          {(step === 'intro' || success) && (
            <RsvpFormHeader page={page} guestGroupRsvp={guestGroupRsvp} wedding={wedding} />
          )}
        </div>
        <div className="entity-sections rsvp-sections">
          <div className="entity-sections-accent-top-left" />
          <div className="entity-sections-accent-top-right" />
          <div className="entity-sections-accent-bottom-left" />
          <div className="entity-sections-accent-bottom-right" />
          <div>
            <form onSubmit={handleSubmit} className="rsvp-guest-form" noValidate>
              <Field
                component={RenderHiddenField}
                type="hidden"
                name="guest_group_id"
                id="rsvp-guest_group_id"
              />
              <Field
                component={RenderHiddenField}
                type="hidden"
                name="wedding_account_id"
                id="rsvp-wedding_account_id"
              />
              {success && (
                <RsvpSuccess
                  wedding={wedding}
                  guests={guests}
                  events={events}
                  pristine={pristine}
                  submitting={submitting}
                  valid={valid}
                  forPreview={forPreview}
                  mealOptionsById={mealOptionsById}
                  selector={selector}
                  success={success}
                  onEditRsvp={() => { onEditRsvp(); this.handleNextStep(0); }}
                />
              )}
              {!success && (
                <div>
                  <MediaQuery query="(min-device-width: 768px)">
                    <div>
                      {events && events.map((event, eventIndex) => (
                        <div key={event.id} className="events-container">
                          <div className={`entity-section rsvp-section${success ? ' rsvp-section-success' : ''}`} ref={(el) => { this[`events[${eventIndex}]`] = el; }}>
                            <EventDetails event={event} />
                            <EventRsvp
                              event={event}
                              eventIndex={eventIndex}
                              guests={guests}
                              wedding={wedding}
                              mealOptionsById={mealOptionsById}
                              success={success}
                              selector={selector}
                              forPreview={forPreview}
                            />
                          </div>
                          {eventIndex < events.length - 1 && (
                            <ScrollButton handleScroll={() => this.handleScroll(eventIndex)} />
                          )}
                        </div>
                      ))}
                      {numEventsRequiringRsvp > 0 && (
                        <div onClick={() => scrollToTop()}>
                          <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid || true} className={'btn-wide'} value="Submit RSVP" onClick={scrollToTop} />
                        </div>
                      )}
                    </div>
                  </MediaQuery>
                  <MediaQuery query="(max-device-width: 768px)">
                    <div className="mobile-rsvp-form">
                      {step === 'intro' ? (
                        <div>
                          <div className="entity-section">
                            <div className="guests-invited">
                              <h4>Name{noPlusOne ? '' : 's'}</h4>
                              {noPlusOne ? (
                                <p>{selector('guests') && selector('guests')[0] && selector('guests')[0].first_name}</p>
                              ) : (
                                <p>{selector('guests') && selector('guests')[0] && selector('guests')[0].first_name} &amp; {selector('guests') && selector('guests').length - 1} Guest{onePlusOne ? '' : 's'}</p>
                              )}
                            </div>
                            <div className="event-invites">
                              <h4>You are invited to</h4>
                              <div className="event-invite-list">
                                {events && events.length > 0 && events.map(event => (
                                  <p key={event.id}>{event.name}</p>
                                ))}
                              </div>
                            </div>
                            <div className="btn btn-primary btn-wide" onClick={() => this.handleNextStep(0)}>RSVP</div>
                          </div>
                        </div>
                      ) : (
                        <div className="events-container">
                          <div className="entity-section rsvp-section">
                            <EventDetails event={events[step]} />
                            <EventRsvp
                              event={events[step]}
                              eventIndex={step}
                              guests={guests}
                              wedding={wedding}
                              mealOptionsById={mealOptionsById}
                              success={success}
                              selector={selector}
                              forPreview={forPreview}
                            />
                          </div>
                          {events && step < events.length - 1 && (
                            <div className="next-event-button-container">
                              <div className="row">
                                <div className="col-xs-6">
                                  {step === 0 ? (
                                    <div className="btn btn-primary prev-event-button" onClick={() => this.handleNextStep('intro')}>&lsaquo; Back</div>
                                  ) : (
                                    <div className="btn btn-primary prev-event-button" onClick={() => this.handleNextStep(step - 1)}>&lsaquo; Previous Event</div>
                                  )}
                                </div>
                                <div className="col-xs-6">
                                  {valid ? (
                                    <div className="btn btn-primary next-event-button" onClick={() => this.handleNextStep(step + 1)}>Next Event &rsaquo;</div>
                                  ) : (
                                    <div className="btn btn-disabled next-event-button" disabled>Next Event &rsaquo;</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                          <div>
                            {events && step === events.length - 1 && numEventsRequiringRsvp > 0 && (
                              <div className="row">
                                <div className="col-xs-6">
                                  <div className="btn btn-primary prev-event-button" onClick={() => this.handleNextStep(step - 1)}>&lsaquo; Previous Event</div>
                                </div>
                                <div className="col-xs-6">
                                  <div onClick={() => scrollToTop()}>
                                    <RenderSubmitButton pristine={pristine} submitting={submitting} className="rsvp-submit-button" valid={valid} value="Submit RSVP" />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </MediaQuery>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

GuestRsvpForm.propTypes = {
  wedding: PropTypes.shape({}),
  guests: PropTypes.arrayOf(PropTypes.shape({})),
  events: PropTypes.arrayOf(PropTypes.shape({})),
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  forPreview: PropTypes.bool,
  mealOptionsById: PropTypes.shape({}),
  selector: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  success: PropTypes.bool,
  onEditRsvp: PropTypes.func,
  page: PropTypes.shape({}),
  guestGroupRsvp: PropTypes.shape({}),
};


const mapStateToProps = (state, ownProps) => {
  const events = ownProps.forPreview
    ? state.website.entities.orderedIds.map(id => state.website.entities.byId[id])
    : state.publicWebsite.guestGroupRsvp.events;

  const previewGuests = [
    {
      id: 'preview-guest',
      name: { firstName: '', familyName: '' },
      event_invitations: events.map(event => ({
        event_id: event.id,
        meal_option_id: null,
        rsvp_type: 'NO_RESPONSE'
      }))
    }
  ];

  const guests = ownProps.forPreview ? (
    previewGuests
  ) : (
    state.publicWebsite.guestGroupRsvp.guests.map(guest => ({
      ...guest,
      name: {
        firstName: guest.first_name,
        familyName: guest.family_name
      },
      event_invitations: guest.event_invitations
    }))
  );


  const rsvpAnswers = ownProps.forPreview
    ? { allIds: [] }
    : state.publicWebsite.guestGroupRsvp.rsvp_answers.reduce((result, answer) => {
      result.allIds.push(answer.rsvp_question_id);
      result[answer.rsvp_question_id] = answer; // eslint-disable-line
      return result;
    }, { allIds: [] });

  const initialRsvpAnswers = ownProps.forPreview
    ? { allIds: [] }
    : _.chain(events)
      .flatMap(event => event.rsvp_questions)
      .reduce((result, question) => {
        result.allIds.push(question.id);
        result[question.id] = { // eslint-disable-line
          rsvp_question_id: question.id,
          answer: rsvpAnswers[question.id] ? rsvpAnswers[question.id].answer : ''
        };
        return result;
      }, { allIds: [] })
      .value();

  const mealOptionsById = _.chain(events)
    .flatMap(event => event.meal_options)
    .reduce((result, mealOption) => {
      result.allIds.push(mealOption.id);
      result[mealOption.id] = mealOption; // eslint-disable-line
      return result;
    }, { allIds: [] })
    .value();

  return {
    initialValues: {
      wedding_account_id: state.publicWebsite.guestGroupRsvp.wedding_account_id,
      guest_group_id: state.publicWebsite.guestGroupRsvp.guest_group_id,
      guests,
      rsvp_answers: initialRsvpAnswers
    },
    page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
    guestGroupRsvp: state.publicWebsite.guestGroupRsvp,
    wedding: ownProps.forPreview ? state.wedding.wedding : state.publicWebsite.wedding,
    guests: state.publicWebsite.guestGroupRsvp.guests,
    events,
    mealOptionsById,
    selector: field => formValueSelector('GuestRsvpForm')(state, field),
    success: state.publicWebsite.guestGroupRsvp.success,
  };
};


const mapDispatchToProps = dispatch => ({
  onSubmit: (guestRsvpRequest) => {
    resetGuestSearchesNotActedOn();
    dispatch(updateGuestRsvpV2(guestRsvpRequest));
  },
  changeField: (fieldName, value) => dispatch(change('GuestRsvpForm', fieldName, value)),
  onEditRsvp: () => dispatch(resetGuestRsvpSuccess()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'GuestRsvpForm',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
  destroyOnUnmount: false
})(GuestRsvpForm));



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvpV2/GuestRsvpForm.jsx
 **/